import {configureStore} from '@reduxjs/toolkit';
import rootReducers from './rootReducer';

export const initializeStore = (preloadedState?: object) => {
  return configureStore({
    reducer: rootReducers,
    preloadedState,
  });
};
